// TODO make it dynamic - UI needed
// https://wiki.edf-sf.com/doku.php/engineering:identifiants_bdd

export default [
  // Number of cycle
  // Power with BESS
  {
    type: 'meter',
    id: 3,
    agg: 'avg',
    period: '15m'
  },
  // Power without BESS
  {
    type: 'setpoint',
    id: 12,
    agg: 'avg',
    period: '15m'
  },

  // Energy with BESS
  // Energy without BESS
  // SOC
  {
    type: 'metric',
    id: 15,
    agg: 'avg',
    period: '30s'
  },
  // Auxiliaries Consumption
  // Weather
  // Weather
  // Container T
  // Alarms

  // EEG - Energy charged
  // EEG - Energy discharged
  // EEG - Power charged
  {
    type: 'battery',
    id: 1,
    agg: 'avg',
    period: '30s'
  },
  // EEG - Power discharged
  // EEG - Füllstände nach Saldierungperiode Anfang
  // EEG - Füllstände nach Saldierungperiode Ende
]


// WEBPACK FOOTER //
// ./src/constants/endpoints-export-config.js